(function () {
    'use strict';

    const module = angular.module('imApp');

    module.component('stockMinMaxAdjust', {
        templateUrl: 'views/components/views/stockMinMaxAdjust/stockMinMaxAdjust.template.html?v=' + module.version, 
        controllerAs: 'vm',
        controller: ['$stateParams', 'utilityService', 'translateService', 'modalService', 'stockMinMaxAdjustService', 'ttGridFactory', function ($stateParams, utilityService, translateService, modalService, stockMinMaxAdjustService, ttGridFactory) {

            // #region VARIABLES & DEFINITIONS

            const vm = this;
            let stockKeyNo = $stateParams.stock_keyno;

            let progress = {
                runProgress: 'START',
                label: 'progressbar',
                field: '',
                max: 0,
                min: 0,
                step: 0,
                finishclose: '1',
                abortclose: false
            };

            let translations = {
                error: '',
                ok: ''
            };

            vm.model = {
                hasDataTask: false,
                setting: {},
                lockedSave: false
            };

            vm.grid = new ttGridFactory({
                rememberId: '',
                config: {
                    editColumns: [
                        { key: 'stock_minimum' },
                        { key: 'stock_maximum' },
                        { key: 'stock_std_orderquantity' },
                        { key: 'is_selected' }
                    ]
                },
                kendo: {
                    height: '100%',
                    sortable: true,
                    aggregate: true,
                    pager: false,
                    selectable: false,
                    filterable: false
                }
            });
            
            // #endregion VARIABLES & DEFINITIONS

            // #region TRANSLATION FUNCTION

            async function translate() {
                let data = await translateService.translateBatch(translations);

                Object.keys(translations).forEach((key) => {
                    if (data?.[key]) translations[key] = data[key];
                });
            }

            // #endregion TRANSLATION FUNCTION

            // #region LOAD PROCEDURE FUNCTION CALLS

            async function loadSetting() {
                vm.model.setting = (await stockMinMaxAdjustService.getStockMinMaxAdjust({ stock_keyno: stockKeyNo }))[0];

                return loadGrid();
            }
            
            // #endregion LOAD PROCEDURE FUNCTION CALLS

            // #region GRID PROCEDURE FUNCTION CALLS

            async function loadGrid() {
                if (vm.model.setting.view_id && vm.model.setting.view_id > '') {
                    vm.grid.dataTask.rememberId = vm.model.setting.view_id;
                }

                if (utilityService.validateParmsValue(vm.model.setting.p2_datatask_keyno) !== true) return;
                if (utilityService.validateParmsValue(vm.model.setting.stock_keyno) !== true) return;

                vm.grid.dataTask.loadData = {
                    method: vm.model.setting.p2_datatask_keyno,
                    parameters: { stock_keyno: vm.model.setting.stock_keyno }
                };

                vm.model.hasDataTask = true;

                if (vm.grid.gridfunc !== null) vm.grid.gridfunc.read();
            }

            // #endregion GRID PROCEDURE FUNCTION CALLS

            // #region SHOW PROGRESSBAR DIALOGUE BOX FUNCTION

            function activateProgress(items) {
                let increment = 1, skip = 0, failed = 0, step = 0;
                progress.step = 0;

                function doStep() {
                    setTimeout(() => {
                        modalService.progressInfo.finishclose = '0';

                        if (progress.runProgress === 'ABORT') {
                            vm.model.lockedSave = false;
                            return;
                        }

                        if (progress.step >= progress.max) {
                            vm.model.lockedSave = false;
                            return;
                        }

                        step = progress.step + skip + failed;
                        progress.field = 'ID: ' + items[step].stock_keyno;
                        modalService.progressInfo.field = progress.field;

                        stockMinMaxAdjustService.saveGrid({
                            stock_minimum: vm.model.setting.stock_minimum,
                            stock_maximum: vm.model.setting.stock_maximum,
                            stock_std_orderquantity: vm.model.setting.stock_std_orderquantity,
                            records: items[step]
                        }).then((response) => {
                            if (response[0].errorcode !== '0') {
                                modalService.show({
                                    type: 'warning',
                                    title: translations.error,
                                    message: response[0].errormessage,
                                    buttons: [{
                                        label: translations.ok,
                                        cssClass: 'btn-warning',
                                        action: (dialogItself) => {
                                            dialogItself.close();

                                            progress.runProgress = 'ABORT';
                                            modalService.progressInfo.finishclose = '1';
                                            modalService.progressInfo.abortclose = true;

                                            doStep();
                                        }
                                    }]
                                });
                            } else {
                                progress.step += increment;
                                modalService.progressInfo.step = progress.step;
                                modalService.progressInfo.finishclose = progress.finishclose;

                                doStep();
                            }
                        });
                    });
                }

                doStep();
            }

            vm.saveChanges = function () {
                vm.model.lockedSave = true;

                let allRows = vm.grid.gridfunc.getAllRows();
                let selectedRows = [];

                allRows.forEach((item) => {
                    if (item.is_selected === '1' || item.is_selected === true) {
                        selectedRows.push({
                            stock_keyno: item.stock_keyno,
                            is_selected: item.is_selected
                        });
                    }
                });
                
                if (selectedRows.length === 0) {
                    vm.model.lockedSave = false;
                    return;
                }

                progress.max = selectedRows.length;
                activateProgress(selectedRows);

                modalService.showProgress(progress).then((value) => {
                    progress.runProgress = value;

                    if (progress.runProgress === 'ABORT') {
                        vm.model.lockedSave = false;
                        return;
                    }

                    if (progress.runProgress === 'FINISH') {
                        vm.model.lockedSave = false;
                        loadGrid();
                    }
                });
            };

            // #endregion SHOW PROGRESSBAR DIALOGUE BOX FUNCTION

            // #region ON INIT FUNCTION

            vm.$onInit = function () {
                translate();
                loadSetting();
            };

		    // #endregion ON INIT FUNCTION
        }]
    });
})();
